import { FRONTEND_HOST, NEW_ARTICLE_DATE, STATIC_CDN_IMAGES } from "@/config/constants";
import { NextSeo, ImageJsonLd, ArticleJsonLd } from "next-seo";
import { cleanTitleForSEO } from "@/utils";
import { STATIC_CDN } from "@/config/constants";
import { useRouter } from "next/router";

export interface IQASEO {
  answer: {
    options: {
      opt1: string;
      opt2: string;
      opt3: string;
      opt4: string;
    };
    text: string;
    solution: string;
    upvoteCount: number;
  };
  isAnswered: boolean;
  isTextAnswered: boolean;
  isImageAnswered: boolean;
  canonicalUrl: string;
  ocrTextClean: string;
  ocrText: string;
  language?: string;
  createdAt: Date;
  videoLanguage: string,
}

export interface IVideoPageHead extends IQASEO {
  title: string;
  ocrTextClean: string;
  metaDescription: string;
  questionId: number;
  answerId?: number;
  canonicalUrl: string;
  keywords: string[];
  pageLocale: string;
  subject: string;
  class: number;
  hasOptions: boolean;
  nextUrl?: string;
  previousUrl?: string;
  videoName?: string;
  videoUrl?: string;
}


const ImageSEO = (props: IVideoPageHead) => {
  return <ImageJsonLd
    images={[
      {
        contentUrl: `${STATIC_CDN}/ss/web-overlay-thumb/${props.answerId}.webp`,
        creditText: "Doubtnut",
        creator: {
          // @ts-ignore
          "@type": "Organization",
          name: "Doubtnut",
        }
      }
    ]}
  />
}

const ArticleSEO = (props: IVideoPageHead) => {
  const titlePrefix = props.videoLanguage ? `[${props.videoLanguage}] ` : "";

  return <ArticleJsonLd
    type="Article"
    url={`${props.canonicalUrl}#article`}
    title={[titlePrefix, props.ocrTextClean?.substring(0, 100)].join("") ?? `[Solved] Free Video Solution ${props.keywords}`}
    keywords={[...props.keywords, props.title].join()} // TODO: ask
    description={props.title}
    dateCreated={props.createdAt.toISOString() ?? NEW_ARTICLE_DATE}
    datePublished={props.createdAt.toISOString() ?? NEW_ARTICLE_DATE}
    dateModified={NEW_ARTICLE_DATE}
    publisherName="Doubtnut"
    publisherLogo={`${STATIC_CDN_IMAGES}/logo_big_tag_compressed.png`}
    authorName={{
      type: "Person",
      name: "Doubtnut Expert",
    }}
    images={[
      `${STATIC_CDN}/ss/web-overlay-thumb/${props.answerId}.webp`
    ]}
  />
}

const VideoPageHead = (props: IVideoPageHead) => {
  const router = useRouter();

  const titlePrefix = props.videoLanguage ? `[${props.videoLanguage}${props.subject === "BIOLOGY" ? " Solution" : ""}] ` : "";
  const metaTitle = [titlePrefix, props.title].filter(Boolean).join("").slice(0, 110);

  const prevNext = [];
  if (props.previousUrl) {
    prevNext.push({ rel: "prev", href: `${FRONTEND_HOST}${props.previousUrl}` });
  }
  if (props.nextUrl) {
    prevNext.push({ rel: "next", href: `${FRONTEND_HOST}${props.nextUrl}` });
  }

  // let qaSEO = null;
  // switch (props.pageType) {
  //   case "vernacular":
  //     qaSEO = <QASEOVernacular {...props} />;
  //     break;
  //   case "english":
  //     switch (props.subject?.toUpperCase()) {
  //       case "MATHS":
  //         qaSEO = <QASEO {...props} />;
  //         break;
  //       case "PHYSICS":
  //         qaSEO = <QASEO {...props} />;
  //         break;
  //       case "CHEMISTRY":
  //         qaSEO = <QASEO {...props} />;
  //         break;
  //       case "BIOLOGY":
  //         qaSEO = <QASEO {...props} />;
  //         break;
  //       default:
  //         qaSEO = <QASEO {...props} />;
  //         break;
  //     }
  //   default:
  //     qaSEO = <QASEO {...props} />;
  //     break;
  // }

  return (
    <>
      <NextSeo
        title={cleanTitleForSEO(titlePrefix, props.title)}
        description={props.metaDescription}
        openGraph={{
          url: `${props.canonicalUrl}#og`,
          description: props.metaDescription,
          images: [{
            url: `${STATIC_CDN}/ss/web-overlay-thumb/${props.answerId}.webp`,
            alt: `${props.title.slice(0, 110)}`,
          }]
        }}
        twitter={{
          cardType: `${STATIC_CDN}/ss/web-overlay-thumb/${props.answerId}.webp`,
        }}
        additionalMetaTags={[
          { name: "name", content: props.ocrTextClean.slice(0, 110).concat(props.questionId.toString()) },
          { name: "url", content: `${FRONTEND_HOST}${router.asPath}` },
          { name: "headline", content: metaTitle },
          { name: "sourceOrganization", content: "Doubtnut" },
          { name: "title", content: metaTitle },
          { name: "twitter:title", content: metaTitle },
          { name: "twitter:description", content: props.metaDescription },
          {
            name: "keywords",
            content: [...props.keywords, props.title].join(),
          },
        ]}
        additionalLinkTags={[
          { rel: "dns-prefetch", href: "https://videos.doubtnut.com", crossOrigin: "true" },
          ...prevNext,
        ]}
        canonical={props.canonicalUrl}
      />
    </>
  )
}

export default VideoPageHead;
